import React from "react";
import { Typography } from "@mui/material";
import useApp from "../../store/contexts/AppContext";

export default function Copyright(props) {
  const {
    appState: { appName },
  } = useApp();

  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      {appName} {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
